import websiteIcon from '../../media/website-icon.svg';
import noWebsiteIcon from '../../media/no-website-icon.svg';
import websiteImg from '../../media/website-img.svg';
import noWebsiteImg from '../../media/no-website-img.svg';
import wwwImage from '../../media/www-website.svg';
import rebrandingWebsiteImg from '../../media/rebranding-website-img.svg';
import rebrandingNoWebsiteImg from '../../media/rebranding-no-website-img.svg';

export const businessNameValidationErrors = {
  required: _TL_('Field must not be empty'),
  type: _TL_('Invalid Character'),
  maxLength: _TL_('Maximum length exceeded'),
  minLength: _TL_('Minimum length not met'),
};

export const websiteValidationErrors = {
  required: _TL_('Business website is required'),
  maxLength: _TL_('Business website exceeds the maximum allowed length'),
  pattern: _TL_('Enter a valid business website'),
};

export const OPTIONS = {
  SIGNUP_EXISTING_WEBSITE: 'existing-website',
  SIGNUP_SMART_PAGES: 'smart-pages',
  USE_MY_WEBSITE: 'use-my-website',
  USE_SMART_PAGES: 'use-smart-pages',
} as const;

export const optionTitles = {
  [OPTIONS.SIGNUP_EXISTING_WEBSITE]: _TL_('I have a website'),
  [OPTIONS.SIGNUP_SMART_PAGES]: _TL_('I don\'t have a website'),
  [OPTIONS.USE_MY_WEBSITE]: _TL_('Use my website'),
  [OPTIONS.USE_SMART_PAGES]: _TL_('Use my Smart Pages'),
};

export const getOptionImages = (isShowIcon: boolean, isRebranding: boolean) => {
  let signupWebsiteImg = isShowIcon ? websiteIcon : websiteImg;
  let signupNoWebsiteImg = isShowIcon ? noWebsiteIcon : noWebsiteImg;
  if (isRebranding) {
    signupWebsiteImg = rebrandingWebsiteImg;
    signupNoWebsiteImg = rebrandingNoWebsiteImg;
  }
  return {
    [OPTIONS.SIGNUP_EXISTING_WEBSITE]: {
      imageSrc: signupWebsiteImg,
      alt: _TL_('website icon'),
    },
    [OPTIONS.SIGNUP_SMART_PAGES]: {
      imageSrc: signupNoWebsiteImg,
      alt: _TL_('no website icon'),
    },
    [OPTIONS.USE_MY_WEBSITE]: {
      imageSrc: websiteImg,
      alt: _TL_('website icon'),
    },
    [OPTIONS.USE_SMART_PAGES]: {
      imageSrc: wwwImage,
      alt: _TL_('www website icon'),
    },
  };
};

export const selectedText = {
  [OPTIONS.SIGNUP_SMART_PAGES]: _TL_('No worries, you can use Microsoft Smart Pages to create a free webpage.'),
  [OPTIONS.USE_SMART_PAGES]: _TL_('Use my website created using Microsoft Smart Pages.'),
};
